module.exports = __webpack_public_path__ + "static/media/retreadables.58a9e6ab.png";